<script lang="ts">
  import { t } from 'svelte-i18n-lingui';

  export let product: { random_assortment: boolean, name: string, description?: string }
</script>


{#if
  (product.random_assortment && product.random_assortment === true)
  || product.name.toLowerCase().includes('colores surtidos')
  // || product.name.toLowerCase().includes('c/surtidos')
  || (product.description && product.description.toLowerCase().includes('surtidos enviados aleatoriamente'))
}
  <div class="random-notice">
    <p>{$t`Design sent randomly according to stock.`}</p>
  </div>
{/if}


<style lang="scss">
  .random-notice {
    padding: 8px 12px 32px;
    background: var(--secondary);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    margin-bottom: -25px;
  }
</style>
